import React, { createContext, useContext, useState, useEffect } from "react";
import useFetch from "../hooks/useAxios";
import { useAuth } from "./authContext";
const UserContext = createContext();

const UserContextProvider = (props) => {
  const [userinfo, setUserInfo] = useState({});
  const { token, authDispatch } = useAuth();

  const getUser = useFetch({
    method: "get",
    url: "api/auth/current-user",
    setter: setUserInfo,
    noHeader:false,
   // trigger: token ? true : false,
    // errMessage: () => {
    //   authDispatch({ type: "LOGOUT" });
    //  },
  });
 useEffect(() => {
   if(token){
    getUser.reFetch();
   }
 
 }, [token]);

  const callApi = () => {
    getUser.reFetch();
  };
  return (
    <>
      {token ? (
        <>
          {getUser.response && (
            <UserContext.Provider
              value={{
                userinfo,
                callApi,
                getUser,
              }}
              {...props}
            >
              {props.children}
            </UserContext.Provider>
          )}
        </>
      ) : (
        <UserContext.Provider
          value={{
            userinfo,
          }}
          {...props}
        >
          {props.children}
        </UserContext.Provider>
      )}
    </>
  );
};
const useUserInfo = () => useContext(UserContext);

export { useUserInfo, UserContextProvider };
